import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsPositions = (areaSelectedId) => apiActionCreator({
  'endpoint': `/wts/catalog/positions?area=${areaSelectedId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_POSITIONS,
    ActionTypes.FETCHED_WTS_POSITIONS,
    [
      ActionTypes.FETCHED_WTS_POSITIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createWtsPositions = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/positions?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_POSITIONS,
        [
          () => {
            dispatch(getWtsPositions(areaSelectedId));
            return {'type': ActionTypes.CREATED_WTS_POSITIONS};
          },
          MessageActions.addMessageBoxInfo('Cargo creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_POSITIONS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsPositions = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/positions?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_POSITIONS,
        [
          () => {
            dispatch(getWtsPositions(areaSelectedId));
            return {'type': ActionTypes.UPDATED_WTS_POSITIONS};
          },
          MessageActions.addMessageBoxInfo('Cargo actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_POSITIONS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsPositionStatus = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/positions-status?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_POSITIONS,
        [
          () => {
            dispatch(getWtsPositions(areaSelectedId));
            return {'type': ActionTypes.UPDATED_WTS_POSITIONS};
          },
          MessageActions.addMessageBoxInfo('Estado actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_POSITIONS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const changeWtsPositionSelected = (positionSelected) => ({
  'type': ActionTypes.CHANGE_WTS_POSITION_SELECTED,
  'payload': positionSelected,
});
